/* ═══════════════════════════════════════════════════
   NAVBAR — Auth Aware (shows login/profile based on state)
   File: src/components/Navbar/Navbar.js (REPLACE)
═══════════════════════════════════════════════════ */

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import { logoutUser } from "../../utils/firebase";

const CSS = `
  .pf-nav { position:fixed; top:0; left:0; right:0; z-index:1000; transition:all 0.4s ease; }
  .pf-nav.scrolled { background:rgba(10,14,26,0.92); backdrop-filter:blur(24px); -webkit-backdrop-filter:blur(24px); border-bottom:1px solid rgba(255,255,255,0.04); box-shadow:0 4px 30px rgba(0,0,0,0.4); }
  .pf-nav-accent { height:2px; background:linear-gradient(90deg,#FF6B35 0%,#FFD23F 35%,#00D4AA 70%,#7C5CFC 100%); opacity:0.5; }
  .pf-nav-inner { max-width:1200px; margin:0 auto; padding:14px 24px; display:flex; align-items:center; justify-content:space-between; }
  .pf-brand { display:flex; align-items:center; gap:10px; text-decoration:none; flex-shrink:0; }
  .pf-brand-icon { width:36px; height:36px; border-radius:12px; background:linear-gradient(135deg,rgba(255,107,53,0.15),rgba(0,212,170,0.1)); border:1px solid rgba(255,107,53,0.2); display:flex; align-items:center; justify-content:center; font-size:1.1em; transition:all 0.3s ease; }
  .pf-brand:hover .pf-brand-icon { box-shadow:0 0 20px rgba(255,107,53,0.3); transform:rotate(-5deg) scale(1.05); }
  .pf-brand-name { font-family:'DM Serif Display',serif; font-size:1.08em; color:#F0F0F5; }
  .pf-brand-name em { font-style:italic; background:linear-gradient(135deg,#FF6B35,#FFD23F); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .pf-links { display:flex; align-items:center; gap:4px; }
  .pf-link { display:flex; align-items:center; gap:7px; padding:8px 16px; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:0.84em; font-weight:600; color:rgba(255,255,255,0.4); text-decoration:none; transition:all 0.25s ease; white-space:nowrap; }
  .pf-link:hover { color:#fff; background:rgba(255,107,53,0.08); }
  .pf-link.active { color:#FF6B35; background:rgba(255,107,53,0.1); box-shadow:inset 0 0 0 1px rgba(255,107,53,0.15); }
  .pf-cta-nav { display:inline-flex; align-items:center; gap:8px; padding:9px 22px; border-radius:50px; background:linear-gradient(135deg,#FF6B35,#FF8A5C); color:#fff !important; font-size:0.82em; font-weight:700; text-decoration:none; transition:all 0.3s ease; box-shadow:0 4px 16px rgba(255,107,53,0.3); }
  .pf-cta-nav:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(255,107,53,0.4); color:#fff; }

  /* Auth buttons */
  .pf-nav-auth { display:flex; align-items:center; gap:8px; }
  .pf-nav-login { padding:8px 18px; border-radius:50px; font-size:0.82em; font-weight:600; color:rgba(255,255,255,0.5); text-decoration:none; border:1.5px solid rgba(255,255,255,0.08); transition:all 0.25s ease; font-family:'Plus Jakarta Sans',sans-serif; }
  .pf-nav-login:hover { background:rgba(255,255,255,0.04); border-color:rgba(255,255,255,0.15); color:#fff; }
  .pf-nav-user { display:flex; align-items:center; gap:8px; padding:6px 16px 6px 8px; border-radius:50px; background:rgba(255,107,53,0.06); border:1px solid rgba(255,107,53,0.12); text-decoration:none; transition:all 0.25s ease; }
  .pf-nav-user:hover { background:rgba(255,107,53,0.1); border-color:rgba(255,107,53,0.2); }
  .pf-nav-avatar { width:28px; height:28px; border-radius:50%; background:linear-gradient(135deg,#FF6B35,#FFD23F); display:flex; align-items:center; justify-content:center; font-size:0.72em; font-weight:800; color:#fff; }
  .pf-nav-username { font-size:0.8em; font-weight:600; color:rgba(255,255,255,0.6); }

  /* hamburger */
  .pf-ham { display:none; flex-direction:column; gap:5px; background:rgba(255,107,53,0.08); border:1px solid rgba(255,107,53,0.15); border-radius:10px; padding:10px 12px; cursor:pointer; }
  .pf-bar { width:22px; height:2px; border-radius:2px; background:rgba(255,255,255,0.65); transition:all 0.3s ease; }
  .pf-ham.open .pf-bar:nth-child(1){transform:rotate(45deg) translate(5px,5px)} .pf-ham.open .pf-bar:nth-child(2){opacity:0} .pf-ham.open .pf-bar:nth-child(3){transform:rotate(-45deg) translate(5px,-5px)}
  .pf-mob { display:none; flex-direction:column; gap:4px; background:rgba(10,14,26,0.98); backdrop-filter:blur(20px); border-top:1px solid rgba(255,255,255,0.04); padding:12px 16px 16px; }
  .pf-mob.open { display:flex; }
  .pf-mlink { display:flex; align-items:center; gap:10px; padding:12px 16px; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:0.92em; font-weight:600; color:rgba(255,255,255,0.5); text-decoration:none; transition:all 0.2s ease; }
  .pf-mlink:hover,.pf-mlink.active { background:rgba(255,107,53,0.1); color:#FF6B35; }
  @media(max-width:768px) { .pf-links{display:none!important} .pf-nav-auth-desktop{display:none!important} .pf-ham{display:flex} }
`;

const LINKS = [
  { to: "/", label: "Home", emoji: "🏠" },
  { to: "/careers", label: "Careers", emoji: "💼" },
  { to: "/streams", label: "Streams", emoji: "📚" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const { user, loading } = useAuth();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);
  useEffect(() => setOpen(false), [loc]);

  const initial = user?.displayName?.[0]?.toUpperCase() || "S";

  return (
    <>
      <style>{CSS}</style>
      <nav className={`pf-nav${scrolled ? " scrolled" : ""}`}>
        <div className="pf-nav-accent" />
        <div className="pf-nav-inner">
          <Link to="/" className="pf-brand">
            <div className="pf-brand-icon">🧭</div>
            <div className="pf-brand-name">
              Path<em>finder</em>
            </div>
          </Link>

          <div className="pf-links">
            {LINKS.map(({ to, label, emoji }) => (
              <Link
                key={to}
                to={to}
                className={`pf-link${loc.pathname === to ? " active" : ""}`}
              >
                <span>{emoji}</span>
                {label}
              </Link>
            ))}
            {user && (
              <Link
                to="/dashboard"
                className={`pf-link${loc.pathname === "/dashboard" ? " active" : ""}`}
              >
                <span>📊</span>Dashboard
              </Link>
            )}
            <Link to="/test" className="pf-cta-nav">
              🚀 Career Test
            </Link>
          </div>

          {/* Auth section - desktop */}
          <div className="pf-nav-auth pf-nav-auth-desktop">
            {!loading &&
              (user ? (
                <Link to="/dashboard" className="pf-nav-user">
                  <div className="pf-nav-avatar">{initial}</div>
                  <span className="pf-nav-username">
                    {user.displayName?.split(" ")[0] || "Student"}
                  </span>
                </Link>
              ) : (
                <>
                  <Link to="/login" className="pf-nav-login">
                    Log In
                  </Link>
                  <Link
                    to="/signup"
                    className="pf-cta-nav"
                    style={{ padding: "8px 18px", fontSize: "0.8em" }}
                  >
                    Sign Up
                  </Link>
                </>
              ))}
          </div>

          <button
            className={`pf-ham${open ? " open" : ""}`}
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            <span className="pf-bar" />
            <span className="pf-bar" />
            <span className="pf-bar" />
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`pf-mob${open ? " open" : ""}`}>
          {LINKS.map(({ to, label, emoji }) => (
            <Link
              key={to}
              to={to}
              className={`pf-mlink${loc.pathname === to ? " active" : ""}`}
            >
              <span>{emoji}</span>
              {label}
            </Link>
          ))}
          <Link to="/test" className="pf-mlink" style={{ color: "#FF6B35" }}>
            <span>🚀</span>Career Test
          </Link>
          {user ? (
            <>
              <Link to="/dashboard" className="pf-mlink">
                <span>📊</span>Dashboard
              </Link>
              <button
                className="pf-mlink"
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onClick={() => logoutUser()}
              >
                <span>🚪</span>Log Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="pf-mlink">
                <span>🔑</span>Log In
              </Link>
              <Link
                to="/signup"
                className="pf-mlink"
                style={{ color: "#FF6B35" }}
              >
                <span>🚀</span>Sign Up Free
              </Link>
            </>
          )}
        </div>
      </nav>
    </>
  );
}
